import { history } from '@cobliteam/store';
import { rootStoreReducer } from '@cobliteam/store/src/reducers';
import { routerMiddleware } from 'connected-react-router';
import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import SagaMiddlewares from './sagas';

const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = (process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const middleware = applyMiddleware(routerMiddleware(history), sagaMiddleware);

export const store = createStore(rootStoreReducer, composeEnhancers(middleware));

SagaMiddlewares(sagaMiddleware);
